import { useAuthContext } from '../../context/auth/auth'
import { useMutation } from '@tanstack/react-query'
import instance from '../api'
import { useSWRConfig } from 'swr'
import { toast } from 'react-toastify'
import axios from 'axios'
import { useTranslation } from 'react-i18next'

interface UpdateUserRequest {
  first_name: string
  last_name: string
  email: string
  username: string
}

const updateUser = async (
  values: UpdateUserRequest,
  token: string,
  userId: number,
) => {
  return instance.patch(`/auth/user/${userId}/`, values, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
}

const useUpdateUser = () => {
  const { token, authClient } = useAuthContext()
  const { mutate } = useSWRConfig()
  const { t } = useTranslation()
  return useMutation({
    mutationFn: (values: UpdateUserRequest) =>
      updateUser(values, token!, authClient?.id!),
    onSuccess: () => {
      mutate('authClient')
      if (authClient?.user_type === 'ADMINISTRATOR') {
        mutate('users')
      }
      toast.success(t('personalInformationHasBeenUpdated'))
    },
    onError: (error) => {
      if (axios.isAxiosError(error)) {
        const errorMessage = error.response?.data?.data?.[0]

        if (errorMessage.includes('reportall_auth_user_email_key')) {
          toast.error(t('duplicateEmail'))
          return
        }
        if (errorMessage.includes('reportall_auth_user_username_key')) {
          toast.error(t('duplicateUsername'))
          return
        }
        toast.error(error.response?.data?.data?.[0])
        return
      }
      toast.error(t('somethingWentWrongPleaseTryAgain'))
    },
  })
}

export default useUpdateUser
